module.exports = __webpack_public_path__ + "static/media/AzoSansLight.497b39f6.woff";